import { ContentViewer, HubItemLayoutContentViewerModel } from "client/Features/Hub/Builder/Viewer/ContentViewer";
import { HubDetailsLayout, MediaContentModel } from "client/Features/Hub/HubDetailsLayout";
import { ReactElement, useMemo } from "react";
import { HubItemComposerDialog } from "../../HubItemComposerDialog/HubItemComposerDialog";
import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { AnnouncementFormModel } from "./EditAnnouncementDialog";
import { EMPTY_ARRAY } from "client/Misc/utils";
import { ExistingHubItemImages } from "client/Api/Hub/common.composer";
import { HubLinkedDocumentViewModel } from "client/Api/Hub/common";
import { LinkedDocumentsViewer } from "client/Features/Hub/LinkedDocumentsViewer";
import { convertLayoutForDetails, convertMediaForDetails } from "client/Features/Hub/converters";

const {
	Step,
	Content,
	BuilderContainer
} = HubItemComposerDialog;

export type ArchivedContentStepProps = {
	isActive: boolean;
	model: AnnouncementFormModel;
	onChangeIsLoading(isLoading: boolean): void;
	originalImages: ExistingHubItemImages;
	infoAlerts?: ReactElement;
};

export const ArchivedContentStep = (props: ArchivedContentStepProps): ReactElement => {
	const {
		isActive,
		model,
		onChangeIsLoading,
		originalImages,
		infoAlerts
	} = props;

	const linkedDocuments: readonly HubLinkedDocumentViewModel[] = model.linkedDocuments ?? EMPTY_ARRAY;

	const media = useMemo(
		(): MediaContentModel => {
			return convertMediaForDetails(
				model.media,
				HubItemKind.Announcement,
				originalImages.coverImage
			);
		},
		[model.media, originalImages.coverImage]
	);

	const layout = useMemo(
		(): HubItemLayoutContentViewerModel => {
			return convertLayoutForDetails(model.layout, originalImages.layoutImages);
		},
		[model.layout, originalImages.layoutImages]
	);

	const linkedDocumentsCount: number = linkedDocuments.length;

	return (
		<Step
			isActive={isActive}
			trackingId="archived-content-step"
		>
			<Content hasNoPadding>
				<BuilderContainer>
					{infoAlerts}
					<HubDetailsLayout>
						<HubDetailsLayout.SimpleTitle
							text={model.title ?? ""}
						/>
						<HubDetailsLayout.Media
							media={media}
							hubItemKind={HubItemKind.Announcement}
						/>
						<HubDetailsLayout.Content>
							<ContentViewer
								hubItemKind={HubItemKind.Announcement}
								layout={layout}
							/>
						</HubDetailsLayout.Content>
						{(linkedDocumentsCount > 0) && (
							<HubDetailsLayout.LinkedDocuments count={linkedDocumentsCount}>
								<LinkedDocumentsViewer
									items={linkedDocuments}
									onChangeIsLoading={onChangeIsLoading}
								/>
							</HubDetailsLayout.LinkedDocuments>
						)}
					</HubDetailsLayout>
				</BuilderContainer>
			</Content>
		</Step>
	);
};
ArchivedContentStep.displayName = "ArchivedContentStep";